"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockTrackerService = void 0;
const config_1 = require("@app/config");
const local_storage_1 = require("@utils/local-storage");
const event_source_service_1 = __importDefault(require("./event-source.service"));
const http_service_1 = require("./http.service");
class BlockTrackerService extends http_service_1.HttpService {
    constructor() {
        super(config_1.CONFIG.baseApiUrl);
        this.addOperation = (block, tokenId, operation) => {
            local_storage_1.LocalStorage.updateValue("BLOCK_TRACKER", { [tokenId]: { block, operation } });
        };
        this.getList = () => local_storage_1.LocalStorage.getValue("BLOCK_TRACKER");
        this.removeOperationsByBlock = (block) => {
            const operations = local_storage_1.LocalStorage.getValue("BLOCK_TRACKER");
            if (!operations) {
                return { notCompleted: {}, completed: {} };
            }
            const [notCompleted, completed] = Object.entries(operations).reduce(([notCompleted, completed], [key, opData]) => {
                if (block >= opData.block) {
                    completed[key] = opData;
                }
                else {
                    notCompleted[key] = opData;
                }
                return [notCompleted, completed];
            }, [{}, {}]);
            local_storage_1.LocalStorage.remove("BLOCK_TRACKER");
            local_storage_1.LocalStorage.updateValue("BLOCK_TRACKER", notCompleted);
            return { notCompleted, completed };
        };
        this.subscribeOnBlockChanges = (action) => event_source_service_1.default.subscribeToEvent("meta.updated", (data) => action(Number(data.blockNumber)));
    }
}
exports.BlockTrackerService = BlockTrackerService;
